<template>
  <div>
    <EquipmentEditHeader
      v-if="isAdmin"
      data-cy="seal-search-view-edit-header"
    />
    <EquipmentTable
      data-cy="seal-search-view-table"
      @select="$emit('select', $event.data as Seals)"
    />
  </div>
</template>

<script setup lang="ts">
import { useSeals } from "@/composables/equipment/seals/seals";
import { provide } from "vue";
import EquipmentEditHeader from "@/components/equipment/EquipmentEditHeader.vue";
import EquipmentTable from "@/components/equipment/EquipmentTable.vue";
import type { Seals } from "gql/api";

const props = defineProps<{
  isAdmin: boolean;
}>();

defineEmits<{
  (event: "select", data: Seals): void;
}>();

const sealsearch = useSeals(props.isAdmin);

provide("equipment", sealsearch);
</script>
